import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createParagraphIn, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIMRoomCardView {
    createBanner(text) {
        const banner = createDivIn(this.cardContainer, 'badge-green badge-sm');
        createParagraphIn(banner, text, '');
    }
    setSelect(isSelected) {
        this.isSelected = isSelected;
        this.cardContainer.classList.toggle('selected', isSelected);
    }
    createClickInteraction() {
        setElementOnClick(this.cardContainer, ()=>{
            if (this.isCardLocked || this.isSelected) {
                this.displayInfoAction();
                return;
            }
            this.onClick();
        });
    }
    constructor(container, text, icon, isCardLocked, isMapCard, onClick, displayInfoAction){
        this.isSelected = false;
        this.isCardLocked = isCardLocked;
        this.onClick = onClick;
        this.displayInfoAction = displayInfoAction;
        this.cardContainer = createDivIn(container, `item-scroll-cell mobile-room-card ${isMapCard ? 'mobile-room-map-card' : ''}`);
        createImgIn(this.cardContainer, icon, 'item-scroll-cell-image');
        createParagraphIn(this.cardContainer, text, 'item-scroll-cell-text');
        if (isCardLocked) {
            createImgIn(this.cardContainer, LobbyImage.Lock, 'item-scroll-cell-lock');
            this.cardContainer.classList.add('unavailable');
        }
        createImgIn(this.cardContainer, LobbyImage.InfoIcon, 'item-scroll-cell-info-icon-mobile');
        this.createClickInteraction();
    }
}
